import { render, staticRenderFns } from "./OfflineNewContent.vue?vue&type=template&id=310e2c7b&scoped=true"
import script from "./OfflineNewContent.vue?vue&type=script&lang=js"
export * from "./OfflineNewContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310e2c7b",
  null
  
)

export default component.exports